import DateService from "utils/date.util";
import BookingCards from "components/templates/BookingCards";

export default function StatusCard({
  data,
  height,
  headingStyle,
  isZonedTime = false,
}: any) {
  if (!data?.logs || data.logs.length === 0) return null;

  // Make a reversed copy to show latest first
  const logs = data.logs.slice().reverse();

  return (
    <BookingCards heading="Status Updates" headingStyle={headingStyle}>
      <div
        className="card-main"
        style={{
          maxHeight: height,
          overflowY: logs.length > 10 ? "auto" : "visible",
        }}
      >
        {logs.map(({ _id, time, message }: any) => (
          <div key={_id || time} className="card-inner-heading status-log-item">
            <div className="status-date">
              {DateService.getBrowserLocalDateTime(time)}
            </div>
            <div className="status-message">{message}</div>
          </div>
        ))}
      </div>
    </BookingCards>
  );
}
